export default __webpack_public_path__ + "static/media/black-logo-with-word.59ff272f.svg";